import * as Yup from 'yup';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const leadCaptureSchema = Yup.object().shape({
  customerType: Yup.string().required(),
  firstName: Yup.string().required('A first name is required'),
  lastName: Yup.string().required('A last name is required'),
  phone: Yup.string()
    .required('A phone number is required')
    .test('phone', 'Invalid phone number format', (value) => (value ? isValidPhoneNumber(value) : false)),
  email: Yup.string().email('Invalid email format').required('An email is required'),
  preferredContactMethod: Yup.string().required('Preferred Contact Method is required'),
  bestTimeToContact: Yup.string().required('A time to contact is required'),
  streetNumber: Yup.string().required('A street number is required'),
  streetName: Yup.string().required('A street name is required'),
  unitNumber: Yup.string(),
  city: Yup.string().required('A city is required'),
  state: Yup.object().nullable().required('A province/state is required'),
  postalCode: Yup.string()
    .required('A postal/ZIP code is required')
    .matches(/^[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d$/i, 'Please enter a valid Canadian postal code (e.g. A1A 1A1)'),

  company: Yup.string().when('customerType', {
    is: 'BUSINESS',
    then: (schema) => schema.required('A business name is required'),
  }),
  businessFields: Yup.object().when('customerType', {
    is: 'BUSINESS',
    then: () =>
      Yup.object({
        companyTradeName: Yup.string().required('A business name is required'),
        industrySector: Yup.object().nullable().required('Selecting a business type is required'),
        serviceOfInterest: Yup.array()
          .of(Yup.object({ value: Yup.string().required(), label: Yup.string().required() }))
          .min(1, 'Selecting at least one service of interest is required'),
        numberOfEmployees: Yup.object().nullable().required('Selecting a business size is required'),
      }),
    otherwise: () => Yup.object().nullable(),
  }),
  typeOfServiceNeeded: Yup.array().min(1, 'Selecting at least one service is required'),
  otherLeadSource: Yup.string().when('howDidYouHear', {
    is: (val: { value?: string } | null | string) =>
      typeof val === 'string' ? val === 'Other' : val?.value === 'Other',
    then: (schema) => schema.required('A response is required'),
    otherwise: (schema) => schema.nullable(),
  }),
});
